var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"soft",attrs:{"variant":_vm.getBadgeVariant(_vm.role)}},[_vm._v(" "+_vm._s(_vm.roleTranslate(_vm.role))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }